import PnmListContainer from './PnmListContainer';

export default PnmListContainer;
